import { render, staticRenderFns } from "./aiDraftCard.vue?vue&type=template&id=c4ec0044&scoped=true"
import script from "./aiDraftCard.vue?vue&type=script&lang=js"
export * from "./aiDraftCard.vue?vue&type=script&lang=js"
import style0 from "./aiDraftCard.vue?vue&type=style&index=0&id=c4ec0044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ec0044",
  null
  
)

export default component.exports